import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";

import Clients from "./Clients";

import { useDispatch, useSelector } from "react-redux";
import { getCustomers } from "../../redux/slices/customers";
import Loader from "../../components/spinners/Loader";
import NotyfContext from "../../contexts/NotyfContext";
import { useWhitelabel } from "../../contexts/WhitelabelContext";

const Customers = () => {
  const dispatch = useDispatch();
  const { customers } = useSelector((state) => state.customers);
  const { user } = useSelector((state) => state.user);
  const { impersonationUser } = useSelector((state) => state.impersonationUser);
  const [activeUser, setActiveUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const notyf = useContext(NotyfContext);
  const { faviconUrl } = useWhitelabel();

  useEffect(() => {
    setActiveUser(impersonationUser.id ? impersonationUser : user);
  }, [user, impersonationUser]);

  useEffect(() => {
    const fetchCustomers = async () => {
      await dispatch(getCustomers())
        .catch((error) => {
          notyf.open({
            type: "danger",
            message: error,
            duration: 5000,
            dismissible: false,
            ripple: true,
            position: {
              x: "center",
              y: "top",
            },
          });
        })
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, [500]);
        });
    };

    if (activeUser.id) {
      fetchCustomers();
    }
  }, [dispatch, activeUser]);

  return (
    <React.Fragment>
      <Helmet title="Customers">
        <link rel="icon" href={faviconUrl} />
      </Helmet>
      <Container fluid className="p-0 w-100 h-100">
        <Clients
          title="Customers"
          clientList={customers}
          isLoading={isLoading}
        />
      </Container>
    </React.Fragment>
  );
};

export default Customers;
